import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Translation provided by Vuetify (javascript)
import it from 'vuetify/lib/locale/it'

Vue.use(Vuetify)
const opts = {
  icons: {
    iconfont: 'mdi',  // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },

  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#27316e",
        secondary: "#f1861b",
        csenBlue: "#27316e",
        csenOrange: "#F1861B",
        csenGreen: "#31794A",
        accent: "#8c9eff",
        error: "#bc2025",
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: "#f1861b",
        secondary: "#fff",
        accent: "#8c9eff",
        error: "#bc2025",
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
    options: {
      // themeCache: {
      //   get: key => localStorage.getItem(key),
      //   set: (key, value) => localStorage.setItem(key, value),
      // },
    },
  },

  lang: {
    locales: { it },
    current: 'it',
  },

}

// if(localStorage.getItem('theme') != null) {
//   console.log(localStorage.getItem('theme'));
//   opts.theme.dark = localStorage.getItem('theme');
// }

export default new Vuetify(opts)